
import { RangerFirearmAssignmentLogEntityDecoratorBase } from './ranger-firearm-assignment-log.decorator.base';


export class RangerFirearmAssignmentLogEntityDecorator extends RangerFirearmAssignmentLogEntityDecoratorBase {
  constructor() {
    super();
  }
}



